// extracted by mini-css-extract-plugin
export default {"container":"CommentCard_container__idvsQ","profilePhoto":"CommentCard_profilePhoto__OhAxJ","content":"CommentCard_content__Os-Yd"};